;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loader = require("../Loader.vue");

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ThreeDSFrame",
  props: {
    acsURL: { type: String, required: true },
    creq: { type: String, required: true },
    is_loading: { type: Boolean, default: false }
  },
  components: {
    loader: _Loader2.default
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (this.acsURL && this.creq) {
      this.$refs.threeDSForm.submit();
    } else {
      console.error("Missing required 3DS parameters: acsURL or creq");
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_loading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('loader')],1):_vm._e(),_vm._v(" "),(!_vm.is_loading)?_c('iframe',{ref:"threeDSFrame",attrs:{"name":"threeDSFrame","width":"400","height":"400"}}):_vm._e(),_vm._v(" "),_c('form',{ref:"threeDSForm",staticClass:"hidden",attrs:{"method":"POST","action":_vm.acsURL,"target":"threeDSFrame"}},[_c('input',{attrs:{"type":"hidden","name":"creq"},domProps:{"value":_vm.creq}})])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d1e6a47a", __vue__options__)
  } else {
    hotAPI.reload("data-v-d1e6a47a", __vue__options__)
  }
})()}